import React from "react";

import { SpecsBlock } from "@reactivated";

import styles from "./index.module.scss";

export function Specs({ value }: { value: SpecsBlock }) {
    return (
        <section className={styles.root}>
            {value.columns?.map(({ value: col, id }) => (
                <div key={id} className={styles.column}>
                    <p>{col.header}</p>
                    <dl className={styles.dl}>
                        {col.cells?.map(({ value: cell, id }) => (
                            <div key={id} className={styles.cell}>
                                <dt>{cell.eyebrow}</dt>
                                <dd>{cell.text}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            ))}
        </section>
    );
}
